module.exports = __webpack_public_path__ + "img/deer.04a9db7.png";